module.exports = __webpack_public_path__ + "img/demo-img.4c126323.jpg";